var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 5.02853C14.35 2.92 17.98 2.99 20.2426 5.25736C22.5053 7.52472 22.583 11.137 20.4786 13.493L11.9999 21.985L3.52138 13.493C1.41705 11.137 1.49571 7.51901 3.75736 5.25736C6.02157 2.99315 9.64519 2.91687 12.001 5.02853ZM18.827 6.6701C17.3279 5.16794 14.9076 5.10701 13.337 6.51687L12.0019 7.71524L10.6661 6.51781C9.09098 5.10597 6.67506 5.16808 5.17157 6.67157C3.68183 8.16131 3.60704 10.5473 4.97993 12.1232L11.9999 19.1543L19.0201 12.1232C20.3935 10.5467 20.319 8.16525 18.827 6.6701Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.b8fff1d57a18b09315852ad63d48b8be.svg";
export { ForwardRef as ReactComponent };